// extracted by mini-css-extract-plugin
export var gatsbyImageWrapper = "about-company-module--gatsby-image-wrapper--a13ad";
export var heroWrap = "about-company-module--heroWrap--37bb1";
export var mission = "about-company-module--mission--6ac3f";
export var missionBody = "about-company-module--missionBody--e51be";
export var missionCta = "about-company-module--missionCta--82252";
export var missionHeading = "about-company-module--missionHeading--a2076";
export var missionImg = "about-company-module--missionImg--8717d";
export var missionInner = "about-company-module--missionInner--51b1d";
export var missionTag = "about-company-module--missionTag--cc234";
export var missionText = "about-company-module--missionText--e358f";